module.exports = __webpack_public_path__ + "static/media/Historical-fashion-hairstyle-345261(1)-min.9f52daa3.jpg";